import { render, staticRenderFns } from "./ProdutoCarrinho.vue?vue&type=template&id=a186a1f8&scoped=true&"
import script from "./ProdutoCarrinho.vue?vue&type=script&lang=js&"
export * from "./ProdutoCarrinho.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoCarrinho.vue?vue&type=style&index=0&id=a186a1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a186a1f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBadge,VImg})
